import React, { useMemo, useEffect } from 'react'
import Box from '../../components/box'
import Button from '../../components/button'
import { UserService } from '../../apilibrary'
import { useAsyncOperation } from '../../hooks/useAsyncOperation'
import Loading from '../../components/loading'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Typography, { TypographyColor } from '../../components/typography'
import useCurrentUserId from '../../hooks/useCurrentUserId'
import { trackSetupPayoutDetails } from '../../utils/analytics'

const StripeSettings: React.FC = () => {
  const {
    runFunction: fetchStripeDetails,
    item: stripeAccount,
    loading: loadingFetchStripeDetails
  } = useAsyncOperation(UserService.getUserStripeAccount)
  const {
    runFunction: getStripeOnboardingLink,
    loading: loadingGetStripeOnboardingLink
  } = useAsyncOperation(UserService.getStripeOnboardingLink)
  const {
    runFunction: getStripeLoginLink,
    loading: loadingGetStripeLoginLink
  } = useAsyncOperation(UserService.getStripeLoginLink)
  const userId = useCurrentUserId();

  useEffect(() => {
    void fetchStripeDetails({})
  }, [fetchStripeDetails])

  const content = useMemo(() => {
    const handleClickSetupPayoutDetails = async (): Promise<void> => {
      const url = await getStripeOnboardingLink('settings/profile')
      await trackSetupPayoutDetails(userId);
      window.open(url, '_blank')
      console.log(url)
    }

    const handlClickGetStripeLoginLink = async (): Promise<void> => {
      const url = await getStripeLoginLink(null)
      window.open(url, '_blank')
    }

    if (loadingFetchStripeDetails) {
      return (<Loading />)
    }

    if (stripeAccount?.chargesEnabled && stripeAccount?.onboarded) {
      return (
        <Button color='secondary' disabled={loadingGetStripeLoginLink} onClick={handlClickGetStripeLoginLink} fullWidth variant='contained'>
          <AccountBalanceIcon sx={{ mr: 2 }} />
          Manage Stripe Account
        </Button>
      )
    }

    return (
      <>
        {stripeAccount?.onboarded && !stripeAccount?.chargesEnabled && (
          <Typography color={TypographyColor.SECONDARY} mb={1} display={'block'} fontSize={16} variant='caption'>
            ...Charges are currently disabled. If you have recently updated your account, please allow up to 5 minutes for your stripe account to active.
          </Typography>
        )}
        <Button
          color={'secondary'}
          disabled={loadingGetStripeOnboardingLink}
          onClick={handleClickSetupPayoutDetails}
          fullWidth
          variant='contained'
        >
          <AccountBalanceIcon sx={{ mr: 2 }} />
          {stripeAccount?.onboarded ? 'Edit Stripe Account' : 'Setup Stripe Account'}
        </Button>
      </>
    )
  }, [getStripeLoginLink, getStripeOnboardingLink, loadingFetchStripeDetails, loadingGetStripeLoginLink, loadingGetStripeOnboardingLink, stripeAccount?.chargesEnabled, stripeAccount?.onboarded, userId])

  return (
    <Box>
      {content}
    </Box>
  )
}

export default StripeSettings
